import { AA_WORK_TEAM_MODAL_COACHMARK_CONFIG } from 'food-benefit.module/common/domain/constants';
import moment from 'moment';

class FoodBenefitWorkTeamController {
  constructor(
    $window,
    FoodBenefitUserDataService,
    ManagerDataService, 
    HelperDelegationsService,
    FoodBenefitInitialDataManagerService
  ) {
    'ngInject';
    this.isMobileApp = $window.innerWidth < 1024;
    this.UserDataService = FoodBenefitUserDataService;
    this.ManagerDataService = ManagerDataService;  
    this.helperDelegationsService = HelperDelegationsService; 
    this.InitialDataManagerService = FoodBenefitInitialDataManagerService;
  }

  $onInit(){
    this.isLoaded = false;
    this.InitialDataManagerService.initMainData().then(() => {
      this.oneSearchIsDone = false;
      this.employeeFilters = [];
      this.userId = this.UserDataService.getEmployee().userId;
      this.manager = this.ManagerDataService.getManager();
      this.teamFoodBenefitsFormatted = this.assembleTeamFoodBenefits(this.manager.employeesFoodBenefitPeriods);
      this.employees = this.formatInexistentMonthsWithCero(this.teamFoodBenefitsFormatted);
      this.rawEmployeePeriods = this.manager.employeesFoodBenefitPeriods;
      this.coachmarkData = AA_WORK_TEAM_MODAL_COACHMARK_CONFIG;
      this.isLoaded = true;
    });
  }

  onSearch() {
    return this.helperDelegationsService.onSearchEmployeeDelegations(this.employees);
  }

  onSelectEmployeeSearch($event) {
    const employeeIdInFilters = this.employeeFilters.find((employee) => employee.employeeId === $event.employeeId);
    if (!employeeIdInFilters)
      this.employeeFilters.push($event);
    this.existFilters = true;
  }

  onCleanSearch($event) {
    if($event.searchText == ''){
      this.employeeFilters = [];
    }
  }

  onCleanSearchPlaceholder($event) {
    if(this.isMobileApp){
      if($event.searchText == ''){
        this.employeeFilters = [];
      }
    }
  }

  reportSearchState($event) {
    this.hasResults = $event.hasResults;
    this.searchText = $event.searchText;
    this.oneSearchIsDone = true;
  }

  noHasResults() {
    return this.hasResults === false && this.oneSearchIsDone === true;
  }

  getClasses() {
    return {
      responsiveMobile: this.isMobileApp,
    };
  }

  assembleTeamFoodBenefits(employeesFoodbenefits) {
    let formattedFoodbenefits = [];
    employeesFoodbenefits.forEach((period) => {
      let existEmployeeInArray = formattedFoodbenefits.find((employee) => employee.employeeId === period.employeeId);
      if(!existEmployeeInArray) {
        let newEmployeeToArray = {
          name: period.name,
          email: period.email,
          employeeId: period.employeeId,
          foodBenefits:[{
            tickets: period.enjoymentDays,
            enjoymentMonth: period.enjoymentMonth
          }]
        };
        formattedFoodbenefits.push(newEmployeeToArray);
      } else {
        let newFoodBenefitToArray = {
          tickets: period.enjoymentDays,
          enjoymentMonth: period.enjoymentMonth
        };
        formattedFoodbenefits.forEach((employee) => {
          if(employee.employeeId === period.employeeId) {
            employee.foodBenefits.push(newFoodBenefitToArray);
          }
        });
      }
    });

    return formattedFoodbenefits;
  }  

  formatInexistentMonthsWithCero(employeesFoodBenefits) {
    const currentMonthNumber = moment().format('MM'); 
    const currentPreviousMonth = moment().month(currentMonthNumber-2).format('MM'); 
    const secondPreviousMonth = moment().month(currentMonthNumber-3).format('MM'); 
    const thirdPreviousMonth = moment().month(currentMonthNumber-4).format('MM'); 
    const fourthPreviousMonth = moment().month(currentMonthNumber-5).format('MM'); 

    const months = [currentPreviousMonth, secondPreviousMonth, thirdPreviousMonth, fourthPreviousMonth];

    employeesFoodBenefits.forEach((employee) => {
      months.forEach((month) => {
        const existMonth = employee.foodBenefits.find((foodBenefit) => foodBenefit.enjoymentMonth === month);

        if(!existMonth) {
          const newMonth = {
            tickets: 0, 
            enjoymentMonth: month,
          };
          employee.foodBenefits.push(newMonth);
        }
      });
    });

    return employeesFoodBenefits;
  }
}

export default FoodBenefitWorkTeamController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitWorkTeam/foodBenefitWorkTeam.controller.js